import { render, staticRenderFns } from "./experienceitem.vue?vue&type=template&id=53bb5d27&"
import script from "./experienceitem.vue?vue&type=script&lang=js&"
export * from "./experienceitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports